module.exports = __webpack_public_path__ + "static/media/87.e25ffdcc.png";